import AuthRequired from '@/component/AuthRequired'
import Drawer from '@/component/Drawer'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import InviteCard from './InviteCard'
import TopUpDiamondMain from './TopUpDiamondMain'

const TopUpDiamondPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const topUpDiamondPopupVisible = useStatePopup(PopupSelector.topUpDiamondPopupVisible)

  const handleClose = () => {
    PopUpStore.setTopUpDiamondPopupVisible(false)
  }

  return (
    <Drawer
      visible={topUpDiamondPopupVisible}
      zIndex={902}
      onClose={handleClose}
      lockScroll={true}
      className="bg-primary-light"
      title={t('modalTitle.topUpDiamond')}
    >
      <AuthRequired onBack={handleClose}>
        <div className="flex flex-col gap-md px-md">
          <TopUpDiamondMain />
          <InviteCard />
        </div>
      </AuthRequired>
    </Drawer>
  )
}

interface PropType {}

export default TopUpDiamondPopup
